import Type from "../Types";
import { setAerialImageryVisible } from "../loader/LoadImagery";
import { loadGeojsonTypeAsync } from "../loader/LoadGeojson";

export function createToggleAssetVisibility(deps) {
  const {
    viewerRef,
    setMapObjects,

    defaultGeojsonStyle,
    basicGeojsonStyle,
    defaultOsmStyle,
    setMapObjectsAssest,
    selectedProject,

    toggleLabelVisibility,
    toggleDirectionalArrows,
    directionArrowSettingRef,

    scanOn,
    toggleScanRoute,

    fetchImpl,
  } = deps || {};

  const safeFetch = fetchImpl || (typeof fetch !== "undefined" ? fetch.bind(window) : null);

  return async function toggleAssetVisibility(item, force = null) {
    try {
      if (!item) return;

      const newVisible = force == null ? !item.visible : force;

      switch (item.type) {
        case Type.ASSET.IMAGERY: {
          if (typeof setAerialImageryVisible === "function") {
            setAerialImageryVisible({ viewerRef, setMapObjects, layerId: item.id, visible: newVisible });
          }
          return;
        }

        case Type.ASSET.GEOJSON_IMAGE: {
          if (item.dataSource) item.dataSource.show = newVisible;
          break;
        }

        case Type.ASSET.THREEDTILES: {
          if (item.tileset) item.tileset.show = newVisible;
          break;
        }

        case Type.ASSET.OSM: {
          if (item.view_type === "line") {
            if (item.dataSource) item.dataSource.show = newVisible;
            if (item.pointCollection) item.pointCollection.show = newVisible;
          } else if (item.view_type === "lanelet") {
            if (item.osmDataSource) item.osmDataSource.show = newVisible;
            if (item.pointCollection) item.pointCollection.show = newVisible;
          }
          break;
        }

        case Type.ASSET.CSV: {
          if (item.dataSource) item.dataSource.show = newVisible;
          break;
        }

        default: {
          const shouldLazyLoad = !!(item.isDisableLoading && item?.geojson?.features?.length === 0 && item?.url);

          if (shouldLazyLoad && !item.visible) {
            if (!safeFetch) break;

            try {
              const res = await safeFetch(item.url);
              if (!res.ok) break;

              const data = await res.json();

              const savedStyles = selectedProject?.layers?.find?.((x) => String(x.id) === String(item.layer_id))?.style;

              await loadGeojsonTypeAsync({
                geojsonData: data,
                id: item.id,
                viewerRef,
                setMapObjects,
                defaultGeojsonStyle,
                basicGeojsonStyle,
                defaultOsmStyle,
                setMapObjectsAssest,
                savedStyles,
              });
            } catch (e) {
              console.error(e);
            }
          } else {
            if (item.dataSource) item.dataSource.show = newVisible;
            if (item.pointCollection) item.pointCollection.show = newVisible;

            if (item.label_visible && typeof toggleLabelVisibility === "function") {
              toggleLabelVisibility(item);
            }
          }

          break;
        }
      }

      if (item.arrow_visibility && typeof toggleDirectionalArrows === "function" && viewerRef?.current) {
        toggleDirectionalArrows(viewerRef.current, item.dataSource, false, directionArrowSettingRef);
      }

      if (scanOn && item.file_name && typeof item.file_name === "string" && item.file_name.toLowerCase().startsWith("route") && typeof toggleScanRoute === "function") {
        toggleScanRoute(item);
      }

      if (typeof setMapObjects === "function") {
        setMapObjects((prev) => prev.map((o) => (o.id === item.id ? { ...o, visible: newVisible, arrow_visibility: false } : o)));
      }
    } catch (err) {
      console.error("toggleAssetVisibility error:", err);
    }
  };
}
